<script>
	import CustomTable from "src/components/CustomTable/CustomTable.svelte";
	import { navigate } from "svelte-routing";

	export let data = [];

	function navigateToDetails(vehicleId) {
		navigate(`/issues/case-management/quotation/${vehicleId}`);
	}
</script>

<CustomTable
	columns={[
		{
			key: "caseNo",
			label: "Case No",
		},
		{
			label: "Vehicle No",
			key: "plateNo",
			type: "link",
			linkBy: "vehicleId",
			linkTo: "/car-management/details/",
		},
		{
			label: "Investigator",
			key: "investigator",
		},
		{ key: "carAssetOwners", label: "Asset Owner", type: "masterdata" },
		{ key: "caseOrigin", label: "Case Origin", type: "masterdata" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "edit",
		},
	]}
	rows={data}
/>
